export default function capsService($http) {

    const urlBase = '/webapi/caps';
    
    const getCourse = code =>
        $http.get(urlBase + '/GetCourseInfo/' + code).then(result => result);

    const getArchivedCourse = (code, date) =>
        $http.get(urlBase + '/GetArchivedCourseInfo/' + code + '/' + date).then(result => result);

    const getSequence = sequenceId =>
        $http.get(urlBase + '/GetSequence/' + sequenceId)
            .then(result => result.data.data);

    return {
        getCourse,
        getArchivedCourse,    
        getSequence,
    };
};
